import gql from "graphql-tag";

export const GET_CURRENT_USER = gql`
    query{
  getCurrentUser{
    _id
    email
    Agent
    Referrer
    Name
    Surname
    Birthday
    ETHWallet
    BSCWallet

    PostalCode
    City
    Address
    MobilePhone
    Skype
    IsAdmin
    TableReferal
    IsWithdrawal
    IsBSCWithdrawal
      
    PassportVerify 
    AddressVerify 
    BerfusVerify 
    StatusMain
    OtherDocuments 
    AllHeirs
    
    Balance
    EconomicUnites
    BonitetUnites 
    ExodusUnites     
    
    EconomicIndex
    PropertyUnites 
    IndexUnites 
    IndustryUnites 

    UnionInvestor
    CreditUnionBank
    CreditUnionBank2
    MarketUniten

    Bitcoin
    UniQum
    UniQumBonus
    UniQumCard
    AurexGold
    BitcoinWallet

    start
    basic
    full
    
    IndividualCertificate
    
    DateRegistration

    TraiderInfo 
    ActivationDate   
    MyCertificates{
      Name
      DateStart
      Sum
      Cost
      ColorBase
      Profit
      DaysPassed
    }
    MerchantRequest {
      MerchantKey
      MerchantHash
      EuroSum
      submitted
      order_currency
      order_id
      status
    }
  }
}
`;
export const GET_ONE_CLIENT = gql`
    query($email: String!){
  getOneClient(email: $email){
    _id
    email
    Agent
    Referrer
    Name
    Surname
    Birthday
    ETHWallet
    BSCWallet
    PostalCode
    Nationality
    Country
    City
    Address
    MobilePhone
    Skype
    IsAdmin
    Balance
    PassportVerify 
    AddressVerify 
    BerfusVerify 
    OtherDocuments 
    TableReferal
    AllHeirs
    StatusMain
    EconomicUnites
    PropertyUnites 
    IndexUnites 
    IndustryUnites 
    BonitetUnites 
    ExodusUnites   
    UnionInvestor
    CreditUnionBank
    CreditUnionBank2
    MarketUniten
    EconomicIndex  
    IndividualCertificate 
    IsWithdrawal
    IsBSCWithdrawal

    Bitcoin
    BitcoinWallet
    UniQum
    UniQumBonus
    UniQumCard
    AurexGold

    start
    basic
    full

    TraiderInfo  
    ActivationDate  
    MyCertificates{
      Name
      DateStart
      Sum
      Cost
      ColorBase
      Profit
      DaysPassed
    }
    MerchantRequest {
      MerchantKey
      MerchantHash
      EuroSum
      submitted
      order_currency
      order_id
      status
    }
  }
}
`;


export const GET_ALL_TEXTS= gql`
    query{
  getAllTexts{
    _id
    PageName
    TextValue
    TextName
  }
}
`;

export const GET_ALL_VARIABLES= gql`
    query{
  getAllVariables{
    _id
    Name
    Value
  }
}
`;

export const GET_ALL_POSTS= gql`
    query{
  getAllPosts{
    _id
    createdAt
    updatedAt
    isPublished
    title
    text
    picture
  }
}
`;

export const GET_ALL_EXODUS_REQUEST= gql`
query{
getAllExodusRequests{
    _id
  email
  Ammount
  Type
  RequestStatus  
  }
}
`;

export const MAKE_ADMIN = gql`
mutation($email: String!, $IsAdmin: Boolean){
  makeAdmin(email: $email, IsAdmin: $IsAdmin)
  {
    _id 
    email
    IsAdmin
  }
}
`;

export const DELETE_USER = gql`
mutation($id: ID){
  deleteUser(id: $id)
    {
      _id
    }
}
`;

export const ADD_NEW_POST = gql`
mutation($id: String, $createdAt : String, $updatedAt: String, $isPublished : Boolean, $title : String, $text : String, $picture : String){
  addNewPost(id: $id, createdAt : $createdAt, updatedAt: $updatedAt, isPublished: $isPublished, title: $title, text: $text, picture: $picture)
    {
      _id
      id
      createdAt
      updatedAt
      isPublished
      title
      text
      picture
    }
}
`;

export const UPDATE_CURRENT_POST = gql`
mutation($_id: ID, $id: String, $createdAt : String, $updatedAt: String, $isPublished : Boolean, $title : String, $text : String, $picture : String){
  updateCurrentPost(_id: $_id, id: $id, createdAt : $createdAt, updatedAt: $updatedAt, isPublished: $isPublished, title: $title, text: $text, picture: $picture)
    {
      _id
      id
      createdAt
      updatedAt
      isPublished
      title
      text
      picture
    }
}
`;

export const DELETE_POST = gql`
mutation($_id: ID){
  deletePost(_id: $_id)
    {
      _id
    }
}
`;

export const CHANGE_PASSWORD = gql`
mutation($email : String!, $password: String!){
    changePassword(email : $email, password: $password)
    {
        _id
        email
        password
  }}
`;

export const CHANGE_STATUS = gql`
mutation($email : String!, $StatusMain: String){
    changeStatus(email : $email, StatusMain: $StatusMain)
    {
        _id
        email
        StatusMain
  }}
`;


export const GIVE_MONEY = gql`
mutation($email : String!, $Sum: Float, $Agent : String){
    giveMoney(email : $email, Sum: $Sum, Agent: $Agent)
      {
        _id
        email
        Balance
        Agent
        
      }
}
`;

export const GIVE_ECONOMIC_UNITES = gql`
mutation($email: String! $Sum: Float
) { giveEconomicUnites(email: $email Sum: $Sum
  ) { _id
      email
      EconomicUnites
  }
}
`;

export const GIVE_ECONOMIC_INDEX = gql`
mutation($email: String! $Sum: Float
) { giveEconomicIndex(email: $email Sum: $Sum
  ) { _id
      email
      EconomicIndex
  }
}
`;

export const GIVE_PROPERTY_UNITES = gql`
mutation($email: String! $Sum: Float
) { givePropertyUnites(email: $email Sum: $Sum
  ) { _id
      email
      PropertyUnites
  }
}
`;

export const GIVE_INDEX_UNITES = gql`
mutation($email: String! $Sum: Float
) { giveIndexUnites(email: $email Sum: $Sum
  ) { _id
      email
      IndexUnites
  }
}
`;

export const GIVE_INDUSTRY_UNITES = gql`
mutation($email: String! $Sum: Float
) { giveIndustryUnites(email: $email Sum: $Sum
  ) { _id
      email
      IndustryUnites
      
  }
}
`;

export const GET_LAST_REGISTRATION = gql`
    query{
  getLastRegistration{
    email
    Name
    Surname
    Referrer
    DateRegistration
  }
}
`;


export const GIVE_BONITET_UNITES = gql`
mutation($email: String! $Sum: Float
) { giveBonitetUnites(email: $email Sum: $Sum
  ) { _id
      email
      BonitetUnites
  }
}
`;

export const GIVE_EXODUS_UNITES = gql`
mutation($email: String! $Sum: Float
) { giveExodusUnites(email: $email Sum: $Sum
  ) { _id
      email
      ExodusUnites
  }
}
`;
export const GIVE_UNION_INVESTOR = gql`
mutation($email: String! $Sum: Float
) { giveUnionInvestor(email: $email Sum: $Sum
  ) { _id
      email
      UnionInvestor
  }
}
`;
export const GIVE_MARKET_UNITEN = gql`
mutation($email: String! $Sum: Float
) { giveMarketUniten(email: $email Sum: $Sum
  ) { _id
      email
      MarketUniten
  }
}
`;
export const GIVE_BITCOIN = gql`
mutation($email: String!, $Sum: Float
) { giveBitcoin(email: $email, Sum: $Sum
  ) { _id
      email
      Bitcoin
  }
}
`;
export const GIVE_BITCOIN_WALLET = gql`
mutation($email: String!, $Sum: Float
) { giveBitcoinWallet(email: $email, Sum: $Sum
  ) { _id
      email
      BitcoinWallet
  }
}
`;
export const GIVE_UNIQUM = gql`
mutation($email: String!, $Sum: Float
) { giveUniQum(email: $email, Sum: $Sum
  ) { _id
      email
      UniQum
  }
}
`;
export const GIVE_UNIQUMBONUS = gql`
mutation($email: String!, $Sum: Float
) { giveUniQumBonus(email: $email, Sum: $Sum
  ) { _id
      email
      UniQumBonus
  }
}
`;
export const GIVE_UNIQUMCARD = gql`
mutation($email: String!, $Sum: Float
) { giveUniQumCard(email: $email, Sum: $Sum
  ) { _id
      email
      UniQumCard
  }
}
`;
export const GIVE_AUREXGOLD = gql`
mutation($email: String!, $Sum: Float
) { giveAurexGold(email: $email, Sum: $Sum
  ) { _id
      email
      AurexGold
  }
}
`;
export const GIVE_CREDIT_UNION_BANK = gql`
mutation($email: String! $Sum: Float
) { giveCreditUnionBank(email: $email Sum: $Sum
  ) { _id
      email
      CreditUnionBank
  }
}
`;
export const GIVE_CREDIT_UNION_BANK_2 = gql`
mutation($email: String! $Sum: Float
) { giveCreditUnionBank2(email: $email Sum: $Sum
  ) { _id
      email
      CreditUnionBank2
  }
}
`;

export const GIVE_START = gql`
mutation($email: String!, $Sum: Float
) { giveStart(email: $email, Sum: $Sum
  ) { _id
      email
      start
  }
}
`;

export const GIVE_BASIC = gql`
mutation($email: String!, $Sum: Float
) { giveBasic(email: $email, Sum: $Sum
  ) { _id
      email
      basic
  }
}
`;

export const GIVE_FULL = gql`
mutation($email: String!, $Sum: Float
) { giveFull(email: $email, Sum: $Sum
  ) { _id
      email
      full
  }
}
`;

export const GIVE_INDIVIDUAL = gql`
mutation($email: String!, $Sum: Float
) { giveIndividual(email: $email, Sum: $Sum
  ) { _id
      email
      IndividualCertificate
  }
}
`;

export const UPDATE_TEXT = gql`
mutation($TextName : String!, $TextValue : String){
  updateText(TextName: $TextName, TextValue : $TextValue)
  {
    _id
    TextName
    TextValue
  }
}
`;

export const UPDATE_VARIABLE = gql`
mutation($Name : String!, $Value : String){
  UpdateVariable(Name: $Name, Value : $Value)
  {
    _id
    Name
    Value
  }
}
`;

export const UPDATE_EXODUS_REQUEST = gql`
mutation($id : ID!, $email: String! $RequestStatus : String $Ammount: Int){
  UpdateExodusRequest(id: $id, email : $email, RequestStatus : $RequestStatus, Ammount : $Ammount)
  {
    _id
    email
    Ammount
    Type
    RequestStatus  
  }
}
`;

export const UPDATE_USER = gql`
mutation ($id : ID!, $email : String!, $newEmail : String, $Name : String, $Surname : String, $Birthday : String, $ETHWallet : String, $BSCWallet: String, $PostalCode : String, $City : String, $Address : String, $MobilePhone : String, $Skype : String, $Agent : String){
  updateUser (
    id: $id, email : $email, newEmail : $newEmail, Name : $Name, Surname : $Surname, Birthday: $Birthday, ETHWallet: $ETHWallet, BSCWallet: $BSCWallet, PostalCode : $PostalCode, City : $City, Address : $Address, MobilePhone : $MobilePhone, Skype : $Skype, Agent : $Agent
  ) 
  {
    _id
    email
    Agent
    Name
    Surname
    Birthday
    ETHWallet
    BSCWallet
    PostalCode
    City
    Address
    MobilePhone
    Skype
    IsAdmin
  }
}
`;

export const UPDATE_USER_CERTIFICATE = gql`
mutation ($email: String!, $ActivationDate: String){
  updateUserCertificate(
    email : $email, ActivationDate : $ActivationDate
  )
  {
    _id
    email
    ActivationDate
  }
}
`;

export const PASSPORT_VERIFY = gql`
mutation($email : String!, $PassportVerify: String){
    PassportVerify(email : $email, PassportVerify: $PassportVerify)
    {
        _id
        email
        PassportVerify
    }
}
`;

export const ADDRESS_VERIFY = gql`
mutation($email : String!, $AddressVerify: String){
    AddressVerify(email : $email, AddressVerify: $AddressVerify)
    {
        _id
        email
        AddressVerify
    }
}
`;

export const BERFUS_VERIFY = gql`
mutation($email : String!, $BerfusVerify: String){
    BerfusVerify(email : $email, BerfusVerify: $BerfusVerify)
    {
        _id
        email
        BerfusVerify
    }
}
`;

export const OTHER_DOCUMENTS = gql`
mutation($email : String!, $OtherDocuments: String){
    OtherDocuments(email : $email, OtherDocuments: $OtherDocuments)
    {
        _id
        email
        OtherDocuments
    }
}
`;

export const ALL_HEIRS = gql`
mutation($email : String!, $AllHeirs: String){
    AllHeirs(email : $email, AllHeirs: $AllHeirs)
    {
        _id
        email
        AllHeirs
    }
}
`;



export const SIGNIN_USER = gql`
mutation ($email : String!, $password : String!){
  signinUser (
    email : $email, password : $password
  ) 
  {
    token
  }
}
`;

export const SIGNUP_USER = gql`
mutation ($email : String!, $MobilePhone : String, $Name : String, $Surname : String, $password : String!, $StatusMain : String, $Agent : String){
  signupUser (
    email : $email, MobilePhone : $MobilePhone, Name : $Name, Surname : $Surname, password : $password, StatusMain : $StatusMain, Agent : $Agent
  )
  {
    email
    Agent
    Name
    Surname
    Birthday
    PostalCode
    City
    Address
    MobilePhone
    Skype
    IsAdmin
  }
}
`;


export const MAKE_WITHDRAWAL_REQUEST = gql`
mutation($id:String!, $MakeResult : String){
  makeWithdrawalRequest(id : $id,MakeResult : $MakeResult)
  {
    _id
    email
    DateRegistration
    Sum 
    Result
  }
}

`;

export const GET_ALL_USERS = gql`
query{
    getAllUsers{
    _id
    email
    Agent
    Referrer
    TableReferal
    Name
    Surname
    Birthday
    ETHWallet
    BSCWallet
    PostalCode
    City
    Address
    MobilePhone
    Skype
    IsAdmin
    Balance
    PassportVerify 
    AddressVerify 
    BerfusVerify 
    OtherDocuments 
    AllHeirs
    StatusMain
    EconomicUnites
    PropertyUnites 
    IndexUnites 
    IndustryUnites 
    BonitetUnites 
    ExodusUnites  
    IsWithdrawal
    IsBSCWithdrawal
    start
    basic
    full  
    EconomicIndex 
    UnionInvestor
    CreditUnionBank
    CreditUnionBank2
    MarketUniten
    IndividualCertificate
    Bitcoin
    BitcoinWallet
    UniQum
    UniQumBonus
    UniQumCard
    AurexGold  
    TraiderInfo    
    ActivationDate
    MyCertificates{
      Name
      DateStart
      Sum
      Cost
      ColorBase
      Profit
      DaysPassed
    }
  }
}`;

export const GET_ALL_USERS_WALLET = gql`
query{
    getAllUsersWallet{
    _id
    email
    Agent
    Referrer
    TableReferal
    Name
    Surname
    Birthday
    ETHWallet
    BSCWallet
    PostalCode
    City
    Address
    MobilePhone
    Skype
    IsAdmin
    Balance
    PassportVerify 
    AddressVerify 
    BerfusVerify 
    OtherDocuments 
    AllHeirs
    StatusMain
    EconomicUnites
    PropertyUnites 
    IndexUnites 
    IndustryUnites 
    BonitetUnites 
    ExodusUnites  
    IsWithdrawal
    IsBSCWithdrawal
    start
    basic
    full  
    EconomicIndex 
    UnionInvestor
    CreditUnionBank
    CreditUnionBank2
    MarketUniten
    IndividualCertificate
    Bitcoin
    BitcoinWallet
    UniQum
    UniQumBonus
    UniQumCard
    AurexGold  
    TraiderInfo    
    ActivationDate
    MyCertificates{
      Name
      DateStart
      Sum
      Cost
      ColorBase
      Profit
      DaysPassed
    }
  }
}`;

export const GET_ALL_WITHDRAWAL_REQUEST_WITH_FILTER = gql`
query($email : String, $TypeRequest : String){
  getAllWithdrawalRequestWithFilter(email : $email,TypeRequest : $TypeRequest)
  {
    _id
    email
    DateRegistration
    Sum 
    Result
  }
}

`;

export const GET_ALL_REFERALS_OF_THIS_USER = gql`
query($email: String!){
    getAllReferalsOfThisUser(email: $email){
    _id
    email
    Agent
    Referrer
    TableReferal
    Name
    Surname
    DateRegistration
    Birthday
    PostalCode
    City
    Address
    MobilePhone
    Skype
    IsAdmin
    Balance
    PassportVerify 
    AddressVerify 
    BerfusVerify 
    OtherDocuments 
    AllHeirs
    StatusMain
    EconomicUnites
    PropertyUnites 
    IndexUnites 
    IndustryUnites 
    BonitetUnites 
    ExodusUnites     
    UniQum  
    }
}`;

export const GET_CURRENT_NEW = gql`
query($_id: String!){
  getCurrentNew(_id: $_id)
  {
    _id
    id
    createdAt
    updatedAt
    isPublished
    title
    text
    picture
  }
}`;

export const GET_ALL_TABLE_REFERALS = gql`
query{
    getAllTableReferal{
    _id
        email
        TableReferal       
    }
}`;

export const BUY_USERS_CERTIFICATE = gql`
mutation($email : String!, $WhatWePay : String, $ElementName : String, $Sum : Float){
  buyUserCertificate(email : $email, WhatWePay : $WhatWePay, ElementName : $ElementName, Sum : $Sum)
  {
    email
    UnionInvestor
    CreditUnionBank
    CreditUnionBank2
    MarketUniten
    Balance
  }
}
`;

export const BUY_SOMETHING = gql`
mutation($email : String!, $WhatWePay : String, $Sum : Float){
  buySomething(email : $email, WhatWePay : $WhatWePay, Sum : $Sum)
  {
    email
    Balance
    EconomicUnites
    BonitetUnites
    ExodusUnites
    
    PropertyUnites
    IndexUnites
    IndustryUnites
    EconomicIndex 
     
    UnionInvestor
    MarketUniten
    CreditUnionBank
    CreditUnionBank2  
    
    IndividualCertificate  
  }
}
`;

export const GET_ALL_CERTIFICATES = gql`
    query{
  getAllCertificates{
    _id
    id
    userid
    email
    agent
    Name
    Sum
    DateStart
    ActivationDate
    Cost
    DaysPassed
    LastUpdate
    ColorBase
    Profit
    CashBonus
    CertNumber
    DistrBonus
  }
}
`;

export const GET_ALL_USER_CERTIFICATES = gql`
query($email: String){
  getAllUserCertificates(email: $email){
    _id
    id
    userid
    email
    agent
    Name
    Sum
    DateStart
    ActivationDate
    Cost
    DaysPassed
    LastUpdate
    ColorBase
    Profit
    CashBonus
    CertNumber
    DistrBonus
  }
}
`;

export const GET_ALL_REFFERAL_CERTIFICATES = gql`
    query{
    getAllRefferalCertificates{
    _id
    id
    userid
    email
    agent
    UserName
    Product
    invested
    unix
    unixCoin
    bonus
    exodus
    exodusCoin
    halfmount
    iterationDo
    iterationNeed
    ActivationDate
    CashBonus
    time
  }
}
`;

export const GET_ALL_USER_REFFERAL_CERTIFICATES = gql`
query($email: String){
  getAllUserRefferalCertificates(email: $email){
    _id
    id
    userid
    email
    agent
    UserName
    Product
    invested
    unix
    unixCoin
    bonus
    exodus
    exodusCoin
    halfmount
    iterationDo
    iterationNeed
    ActivationDate
    CashBonus
    time
  }
}
`;

export const UPDATE_CURRENT_CERTIFICATE = gql`
mutation($id : String, $ActivationDate : String, $CertNumber : String){
  updateCurrentCertificate(id : $id, ActivationDate : $ActivationDate, CertNumber : $CertNumber)
  {
    _id
    id
    userid
    email
    agent
    Name
    Sum
    DateStart
    ActivationDate
    Cost
    DaysPassed
    LastUpdate
    ColorBase
    Profit
    CashBonus
    CertNumber
    DistrBonus
  }
}
`; 

export const DELETE_CURRENT_CERTIFICATE = gql`
mutation($id : String){
  deleteCurrentCertificate(id : $id)
  {
    _id
    id
  }
}
`; 

export const BUY_NEW_CERTIFICATE = gql`
mutation($email : String!, $WhatWePay : String, $ElementName : String, $Sum : Float){
  buyUserNewCertificate(email : $email, WhatWePay : $WhatWePay, ElementName : $ElementName, Sum : $Sum)
  {
    email    
    Balance
    EconomicUnites
    start
    basic
    full
    IndividualCertificate
  }
}
`;

export const BONUS_DISTRIBUTION = gql`
mutation($Sum : Float, $AllSum: Float){
  distributionBonus(Sum : $Sum, AllSum : $AllSum)
  {
    _id
  }
}
`;

export const GET_ALL_OFFERS = gql`
query{
  getAllOffers{
    _id
    email
    agent
    arno
    ammount
    coin_ammount
    status
    request_id
    item_name
    currency1
    currency2
    status_url
    payment_time
  }
}
`;

export const GET_ALL_ALL_OFFERS = gql`
query{
  getAllAllOffers{
    _id
    email
    agent
    arno
    ammount
    coin_ammount
    status
    request_id
    item_name
    currency1
    currency2
    status_url
    payment_time
  }
}
`;

export const GET_USER_OFFERS = gql`
query($email: String){
  getCurrentUserOffers(email: $email)
  {
      _id
      email
      agent
      arno
      ammount
      coin_ammount
      status
      request_id
      item_name
      currency1
      currency2
      status_url
      payment_time
  }
}`;

export const GET_AGENT_OFFERS = gql`
query($email: String){
  getCurrentAgentOffers(email: $email)
  {
      _id
      email
      agent
      arno
      ammount
      coin_ammount
      status
      request_id
      item_name
      currency1
      currency2
      status_url
      payment_time
  }
}`;

export const GET_PAYPAL_REQUEST = gql`
query($email: String){
  getPayPalRequest(email: $email){
    email
    arno
    value
    currency
    request_id
    intent
    status
    item_name
    create_time
    pay_link
  }
}`;

export const GET_ALL_PAYPAL = gql`
query{
  getAllPayPal{
    email
    arno
    value
    currency
    request_id
    intent
    status
    item_name
    create_time
    pay_link
  }
}
`;

export const GET_ALL_ALL_PAYPAL = gql`
query{
  getAllAllPayPal{
    email
    arno
    value
    currency
    request_id
    intent
    status
    item_name
    create_time
    pay_link
  }
}
`;

export const GIVE_PACKAGE = gql`
mutation($email : String!, $SumPackage: Float, $Agent: String, $Package: String){
  givePackage(email : $email, SumPackage: $SumPackage, Agent: $Agent, Package: $Package)
    {
      _id
      email
      agent
      arno
      ammount
      coin_ammount
      status
      request_id
      item_name
      currency1
      currency2
      status_url
      payment_time 
  }}
`;

export const GET_PAYEER_REQUEST = gql`
query($email: String){
  getPayeerRequest(email: $email){
    email
    arno
    value
    currency
    request_id
    status
    item_name
    create_time
    pay_link
  }
}`;

export const GET_ALL_PAYEER = gql`
query{
  getAllPayeer{
    email
    arno
    value
    currency
    request_id
    status
    item_name
    create_time
    pay_link
  }
}
`;

export const GET_ALL_ALL_PAYEER = gql`
query{
  getAllAllPayeer{
    email
    arno
    value
    currency
    request_id
    status
    item_name
    create_time
    pay_link
  }
}
`;

export const GET_ONE_RATES = gql`
query($Name: String!){
  getOneRates(Name: $Name){
    _id
    Name
    Value
  }
}`

export const UPDATE_ONE_RATES = gql`
mutation($Name : String!, $Value: Float){
  updateOneRates(Name : $Name, Value: $Value){
    _id
    Name
    Value
  }
}
`;

export const GET_USER_STEAKING = gql`
query($userid: String!){
  getUserSteaking(userid: $userid){
    _id
    userid
    email
    name
    surname
    depositStart
    deposit
    DateStart
    DateEnd
    Cost
    DaysPassed
    LastUpdate
    Profit
    DailyProfit
    status
    close
  }
}`

export const GET_STEAKING_COINS = gql`
query{
  getSteakingCoins{
    allToken
    availableToken
    profit
  }
}`

export const GET_ALL_STEAKING = gql`
query{
  getAllSteaking{
    _id
    userid
    email
    name
    surname
    depositStart
    deposit
    DateStart
    DateEnd
    Cost
    DaysPassed
    LastUpdate
    Profit
    DailyProfit
    status
    close
  }
}`

export const GET_ALL_OPEN_STEAKING = gql`
query{
  getAllOpenSteaking{
    _id
    userid
    email
    name
    surname
    depositStart
    deposit
    DateStart
    DateEnd
    Cost
    DaysPassed
    LastUpdate
    Profit
    DailyProfit
    status
    close
  }
}`

export const GET_ALL_CLOSE_STEAKING = gql`
query{
  getAllCloseSteaking{
    _id
    userid
    email
    name
    surname
    depositStart
    deposit
    DateStart
    DateEnd
    Cost
    DaysPassed
    LastUpdate
    Profit
    DailyProfit
    status
    close
  }
}`

export const CLOSE_STEAKING = gql`
mutation($steakid: String!){
  closeSteaking(steakid: $steakid){
    _id
    userid
    email
    name
    surname
    depositStart
    deposit
    DateStart
    DateEnd
    Cost
    DaysPassed
    LastUpdate
    Profit
    DailyProfit
    status
    close
  }
}`;

export const GET_ALL_STEAKING_HISTORY = gql`
query{
  getAllSteakingHistory{
    _id
    steakid
    userid
    email
    deposit
    date
    direction
    directionName
  }
}`

export const CREATE_STAKING = gql`
mutation($email: String, $name: String, $surname : String, $deposit : Float, $days: Int, $percent: Float){
  createStaking(email: $email, name: $name, surname: $surname, deposit: $deposit, days: $days, percent: $percent){
    _id
    userid
    email
    name
    surname
    depositStart
    deposit
    DateStart
    DateEnd
    Cost
    DaysPassed
    LastUpdate
    Profit
    DailyProfit
    status
    close
    type
  }
}`;

export const GET_ALL_KYC = gql`
query{
  getAllKYC{
    _id
    email
    createdAt
    status
    start
    doc_type
    doc1
    doc2
    selfie
    status_doc1
    status_doc2
    status_selfie
  }
}`;

export const GET_USER_KYC = gql`
query($email: String!){
  getUserKYC(email: $email)
  {
    _id
    email
    createdAt
    status
    start
    doc_type
    doc1
    doc2
    selfie
    status_doc1
    status_doc2
    status_selfie
  }
}`;

export const KYC_CONFIRM = gql`
mutation($email: String!){
  ConfirmKYC(email: $email){
    _id
    user_id
    email
    createdAt
    status
    start
    doc_type
    doc1
    doc2
    selfie
    status_doc1
    status_doc2
    status_selfie
  }
}`;

export const KYC_REJECT = gql`
mutation($email: String!){
  RejectKYC(email: $email){
    _id
    user_id
    email
    createdAt
    status
    start
    doc_type
    doc1
    doc2
    selfie
    status_doc1
    status_doc2
    status_selfie
  }
}`;

export const KYC_DELETE = gql`
mutation($email: String!){
  DeleteKYC(email: $email){
    _id
    user_id
    email
    createdAt
    status
    start
    doc_type
    doc1
    doc2
    selfie
    status_doc1
    status_doc2
    status_selfie
  }
}`;

export const KYC_CONFIRM_DOC = gql`
mutation($email: String!, $type: String!){
  ConfirmKYCDoc(email: $email, type: $type){
    _id
    user_id
    email
    createdAt
    status
    start
    doc_type
    doc1
    doc2
    selfie
    status_doc1
    status_doc2
    status_selfie
  }
}`;

export const KYC_REJECT_DOC = gql`
mutation($email: String!, $type: String!){
  RejectKYCDoc(email: $email, type: $type){
    _id
    user_id
    email
    createdAt
    status
    start
    doc_type
    doc1
    doc2
    selfie
    status_doc1
    status_doc2
    status_selfie
  }
}`;